import { mutation, query } from "gql-query-builder";
import { buildVariables } from "../libs/GraphQueryBuilder";
import {
  CreateVoteMutationVariables,
  GetVoteByUserIDQueryVariables,
  ModelVoteFilterInput,
  Tier,
  UpdatePollMutationVariables,
  UpdateVoteMutationVariables,
  VoteType,
  ListVotesByPollQueryVariables,
  CreateVoteInput,
  ListVotesByProxyQueryVariables,
  ListVotesByPollByProxyQueryVariables,
  DeleteVoteMutationVariables,
  SyncVoteMutationVariables,
} from "../API";
import { getPollDetail, editPoll } from "./PollsManager";

import API, { GraphQLResult } from "@aws-amplify/api";
import { getPackageByUserID } from "./PackageManager";
import { checkProxyHandlePoll, checkProxyHandleUser } from "./UsersManager";

export async function listVotedUser(pollID: string) {
  const _variables: ListVotesByPollQueryVariables = {
    pollID,
    filter: {
      type: { eq: VoteType.VOTE },
    },
  };
  const variables = buildVariables<ListVotesByPollQueryVariables>(_variables, [
    { key: "pollID", name: "ID!" },
    { key: "filter", name: "ModelVoteFilterInput" },
  ]);
  const q = query({
    operation: "result: listVotesByPoll",
    fields: [
      {
        items: [
          "id, userID",
          {
            option: [
              "id",
              "title",
              "description",
              { detail: ["video", "price", "currency"] },
            ],
          },
          {
            user: [
              "email",
              "phone",
              "firstName",
              "lastName",
              "username",
              "yearOfBirth",
              "gender",
            ],
          },
        ],
      },
    ],
    variables,
  });
  return API.graphql(q);
}

export async function getVotedPollInfo(fields: any[], userID: string, pollID) {
  const _variables: GetVoteByUserIDQueryVariables = {
    userID,
  };
  if (pollID != null) {
    _variables.filter = {
      pollID: { eq: pollID },
      type: { ne: VoteType.WITHDRAW },
    };
  } else {
    _variables.filter = { type: { ne: VoteType.WITHDRAW } };
  }

  const variables = buildVariables<GetVoteByUserIDQueryVariables>(_variables, [
    { key: "userID", name: "ID!" },
    { key: "filter", name: "ModelVoteFilterInput" },
  ]);

  // fields = [{
  //     items: [
  //         'subPollID',
  //         { option: ['id'] }
  //     ]
  // }]

  const q = query({
    operation: "result: getVoteByUserID",
    fields,
    variables,
  });

  const result = await API.graphql(q);
  return result;
}

export type PollPeriod = {
  startTime?: string | null;
  endTime?: string | null;
  pledgePeriod1StartTime?: string | null;
  pledgePeriod1EndTime?: string | null;
  pledgePeriod2StartTime?: string | null;
  pledgePeriod2EndTime?: string | null;
};

export async function voteSwingPolls(
  pollID,
  userID,
  optionID,
  period: PollPeriod
) {
  // const poll: any = await getPollDetail(['status',{"drawOptions": ["id"]}], pollID)
  // const {drawOptions, status} = poll.data.result
  // if (status !== 'SWING') {
  //     return Promise.reject({error: "Poll is not in SWING"})
  // }
  // let canVote = drawOptions.find(op => op.id === optionID)
  // if (!canVote) {
  //     return Promise.reject({error: "Can only vote for draw options"})
  // }
  const _variables: CreateVoteMutationVariables = {
    input: {
      id: `${pollID}.swing`,
      pollID,
      userID,
      type: VoteType.VOTE,
      option: { id: optionID },
    },
  };
  const query = createVoteQuery(["id"], _variables);
  const votedRes: any = await API.graphql(query);
  console.log(`votedRes ${JSON.stringify(votedRes)}`);
  const { pledgePeriod1StartTime, pledgePeriod1EndTime } = period;
  const updatePollVariables: UpdatePollMutationVariables = {
    input: {
      id: pollID,
      pledgePeriod1StartTime,
      pledgePeriod1EndTime,
    },
  };

  return editPoll(
    [
      "id",
      "pledgePeriod1StartTime",
      "pledgePeriod1EndTime",
      "pledgePeriod2StartTime",
      "pledgePeriod2EndTime",
    ],
    pollID,
    updatePollVariables,
    undefined
  );
}

export async function proxyVotePoll(
  proxyUserID: string,
  userID: string,
  optionID: string,
  pollID: string,
  subPollID?: string
) {
  const handleUser: boolean = await checkProxyHandleUser(proxyUserID, userID);
  if (!handleUser) {
    throw new Error("proxy is not assigned to user");
  }
  // const handlePoll: any = await checkProxyHandlePoll(proxyUserID, pollID)
  // if (handlePoll === undefined) {
  //     throw new Error('proxy is not assigned to poll')
  // }

  const input: CreateVoteInput = {
    id: `${pollID}.${userID}.${optionID}`,
    pollID,
    userID,
    proxyUserID,
    type: VoteType.VOTE,
    option: { id: optionID },
  };
  if (input && subPollID != undefined) {
    input.id = `${pollID}.${subPollID}.${userID}.${optionID}`;
    input.subPollID = subPollID;
  }

  return vote(["id"], input);
}

export async function proxyWithdrawPoll(
  proxyUserID: string,
  userID: string,
  pollID: string,
  reason: string
) {
  // const handleUser: boolean = await checkProxyHandleUser(proxyUserID, userID)
  // if (!handleUser) {
  //     throw new Error('proxy is not assigned to user')
  // }
  // const handlePoll: any = await checkProxyHandlePoll(proxyUserID, pollID)
  // if (handlePoll === undefined) {
  //     throw new Error('proxy is not assigned to poll')
  // }
  return withdrawVotePoll(["id"], pollID, null, userID, reason, true);
}

export async function proxyWithdrawPollAll(
  userID: string,
  pollID: string,
  reason: string | null
) {
  // const handleUser: boolean = await checkProxyHandleUser(proxyUserID, userID)
  // if (!handleUser) {
  //     throw new Error('proxy is not assigned to user')
  // }
  // const handlePoll: any = await checkProxyHandlePoll(proxyUserID, pollID)
  // if (handlePoll === undefined) {
  //     throw new Error('proxy is not assigned to poll')
  // }
  const votes: any = await getVotedPollInfo(
    [
      {
        items: ["subPollID", { option: ["id"] }],
      },
    ],
    userID,
    pollID
  );

  return await Promise.all(
    votes.data?.result.items.map(async (item) => {
      let subPollID = item.subPollID ? item.subPollID : null;

      await withdrawVotePoll(
        ["id"],
        pollID,
        subPollID,
        userID,
        reason,
        item.option.id
      );
      // await withdrawVotePoll(["id"], pollID, subPollID, userID, reason);
    })
  );

  return withdrawVotePoll(["id"], pollID, null, userID, reason, true);
}

export function listVotesByProxy(proxyUserID: string) {
  const _variables: ListVotesByProxyQueryVariables = {
    proxyUserID,
  };
  const variables = buildVariables<ListVotesByProxyQueryVariables>(_variables, [
    { key: "proxyUserID", name: "ID" },
  ]);
  const q = query({
    operation: "result: listVotesByProxy",
    fields: [
      {
        items: [
          "id",
          "pollID",
          "userID",
          { user: ["email", "firstName"] },
          { option: ["id", "title", "description"] },
        ],
      },
    ],
    variables,
  });
  return API.graphql(q);
}

export async function listProxyVotesByPoll(
  pollID: string,
  proxyUserID?: string
) {
  const _variables: ListVotesByPollByProxyQueryVariables = {
    pollID,
    proxyUserID: proxyUserID ? { eq: proxyUserID } : undefined,
    filter: {
      type: { eq: VoteType.VOTE },
    },
  };
  const variables = buildVariables<ListVotesByPollByProxyQueryVariables>(
    _variables,
    [
      { key: "pollID", name: "ID" },
      { key: "proxyUserID", name: "ModelIDKeyConditionInput" },
      { key: "filter", name: "ModelVoteFilterInput" },
    ]
  );
  const q = query({
    operation: "result: listVotesByPollByProxy",
    fields: [
      {
        items: [
          "id",
          "userID",
          "createdAt",
          {
            option: [
              "id",
              "title",
              "description",
              { detail: ["video", "price", "currency"] },
            ],
          },
          {
            user: [
              "email",
              "phone",
              "firstName",
              "lastName",
              "username",
              "yearOfBirth",
              "gender",
            ],
          },
        ],
      },
    ],
    variables,
  });
  return API.graphql(q);
}

export async function vote(fields: any[], input: CreateVoteInput) {
  const _variables: CreateVoteMutationVariables = {
    input,
  };
  const query = createVoteQuery(fields, _variables);
  return API.graphql(query);
}

// Creat vote when user havent voted a poll yet
export async function votePoll(
  fields: any[],
  pollID: string,
  subPollID: string | null,
  userID: string,
  optionID: string,
  isGuest: boolean
) {
  const _variables: CreateVoteMutationVariables = {
    input: {
      id: `${pollID}.${userID}.${optionID}`,
      pollID,
      userID,
      reason: null,
      type: VoteType.VOTE,
      option: { id: optionID },
    },
  };
  if (_variables.input && subPollID != null) {
    _variables.input.id = `${pollID}.${subPollID}.${userID}.${optionID}`;
    _variables.input.subPollID = subPollID;
  }
  let query = createVoteQuery(fields, _variables);
  if (isGuest) {
    query = Object.assign(query, { authMode: "AWS_IAM" });
  }
  await API.graphql(query);
}

// withdraw a vote of a poll
export async function withdrawVotePoll(
  fields: any[],
  pollID: string,
  subPollID: string | null,
  userID: string,
  reason: string | null,
  proxy: boolean = false
) {
  // if (!proxy) {
  //     const packageSub = await getPackageByUserID(userID);
  //     if (!packageSub || packageSub?.tier == Tier.FREE) {
  //         throw new Error("Free tier doesnt support withdrawal")
  //     }
  // }

  const _variables: UpdateVoteMutationVariables = {
    input: {
      id: `${pollID}.${userID}`,
      pollID,
      userID,
      type: VoteType.WITHDRAW,
      reason,
    },
    condition: {
      type: { ne: VoteType.WITHDRAW },
    },
  };
  console.log(_variables);
  if (_variables.input && subPollID != null) {
    _variables.input.id = `${pollID}.${subPollID}.${userID}`;
    _variables.input.subPollID = subPollID;
  }
  const query = updateVoteQuery(fields, _variables);
  await API.graphql(query);
}

export async function newWithdrawVotePoll(
  fields: any[],
  pollID: string,
  subPollID: string | null,
  userID: string,
  reason: string | null,
  optionsId: string,
  proxy: boolean = false
) {
  // if (!proxy) {
  //     const packageSub = await getPackageByUserID(userID);
  //     if (!packageSub || packageSub?.tier == Tier.FREE) {
  //         throw new Error("Free tier doesnt support withdrawal")
  //     }
  // }
  const _variables: UpdateVoteMutationVariables = {
    input: {
      id: `${pollID}.${userID}.${optionsId}`,
      pollID,
      userID,
      type: VoteType.WITHDRAW,
      reason,
    },
    condition: {
      type: { ne: VoteType.WITHDRAW },
    },
  };
  console.log(_variables);
  if (_variables.input && subPollID != null) {
    _variables.input.id = `${pollID}.${subPollID}.${userID}.${optionsId}`;
    _variables.input.subPollID = subPollID;
  }
  const query = updateVoteQuery(fields, _variables);
  await API.graphql(query);
}

export async function DeleteVote(
  pollID: string,
  subPollID?: string,
  userID?: string,
  optionsId?: string
) {
  const _variables: DeleteVoteMutationVariables = {
    input: {
      id: `${pollID}.${userID}.${optionsId}`,
    },
  };

  if (_variables.input && subPollID != null) {
    _variables.input.id = `${pollID}.${subPollID}.${userID}.${optionsId}`;
  }
  const variables = buildVariables<DeleteVoteMutationVariables>(_variables, [
    { name: "input", key: "DeleteVoteInput" },
  ]);
  console.log(variables);
  return API.graphql(
    mutation({
      operation: "result: deleteVote",
      fields: [],
      variables,
    })
  );
}

export async function withdrawAllVotesInGroupPoll(
  userID: string,
  pollID: string,
  reason: string
) {
  const votes: any = await getVotedPollInfo(
    [
      {
        items: ["subPollID", { option: ["id"] }],
      },
    ],
    userID,
    pollID
  );
  await Promise.all(
    votes.data?.result.items.map((item) => {
      let subPollID = item.subPollID ? item.subPollID : null;
      return withdrawVotePoll(["id"], pollID, subPollID, userID, reason);
    })
  );
  return { message: "success" };
}
export async function newWithdrawAllVotesInGroupPoll(
  userID: string,
  pollID: string,
  reason: string | null
) {
  const votes: any = await getVotedPollInfo(
    [
      {
        items: ["subPollID", { option: ["id"] }],
      },
    ],
    userID,
    pollID
  );
  await Promise.all(
    votes.data?.result.items.map(async (item) => {
      let subPollID = item.subPollID ? item.subPollID : null;

      await newWithdrawVotePoll(
        ["id"],
        pollID,
        subPollID,
        userID,
        reason,
        item.option.id
      );
      // await withdrawVotePoll(["id"], pollID, subPollID, userID, reason);
    })
  );
  // await Promise.all(
  //   votes.data?.result.items.map(async (item) => {
  //     let subPollID = item.subPollID ? item.subPollID : null;

  //     await withdrawVotePoll(["id"], pollID, subPollID, userID, reason);
  //   })
  // );
  return { message: "success" };
}

// User vote another option of a poll after withdrawal from another
export async function voteAnother(
  fields: any[],
  pollID: string,
  subPollID: string | null,
  userID: string,
  optionID: string,
  isGuest: boolean
) {
  const _variables: UpdateVoteMutationVariables = {
    input: {
      id: `${pollID}.${userID}.${optionID}`,
      pollID,
      userID,
      type: VoteType.VOTE,
      option: { id: optionID },
    },
  };
  if (_variables.input && subPollID != null) {
    _variables.input.id = `${pollID}.${subPollID}.${userID}.${optionID}`;
    _variables.input.subPollID = subPollID;
  }
  let query = updateVoteQuery(fields, _variables);
  if (isGuest) {
    query = Object.assign(query, { authMode: "AWS_IAM" });
  }
  await API.graphql(query);
}

export function updateVoteQuery(
  fields: any[],
  _variables: UpdateVoteMutationVariables
) {
  const variables = buildVariables<UpdateVoteMutationVariables>(_variables, [
    { key: "input", name: "UpdateVoteInput!" },
    { key: "condition", name: "ModelVoteConditionInput" },
  ]);

  return mutation({
    operation: "result: updateVote",
    fields,
    variables,
  });
}

export function createVoteQuery(
  fields: any[],
  _variables: CreateVoteMutationVariables
) {
  const variables = buildVariables<CreateVoteMutationVariables>(_variables, [
    { key: "input", name: "CreateVoteInput!" },
    { key: "condition", name: "ModelVoteConditionInput" },
  ]);

  return mutation({
    operation: "result: createVote",
    fields,
    variables,
  });
}

export async function syncVote(id: string) {
  const _variables: SyncVoteMutationVariables = {
    input: {
      guestID: id,
    },
  };
  const variables = buildVariables<SyncVoteMutationVariables>(_variables, [
    { key: "input", name: "SyncVoteInput!" },
  ]);
  const q = mutation({
    operation: "result: syncVote",
    fields: [],
    variables,
  });

  return API.graphql(q);
}

export async function syncVoteData(id: string) {
  return ((await syncVote(id)) as GraphQLResult<{ result: any }>).data?.result;
}
